/*
 * OKAYA PRODUCTRASTER — kleurkiezer op de productkaart.
 *
 * Klikken op een kleurstelling wisselt de foto en de kleurnaam, zonder de
 * pagina te verlaten. Zo kan iemand door de kleuren bladeren op het moment
 * dat hij nog aan het kiezen is.
 *
 * De kleurwaarden komen uit assets/okaya-colourways.json, gemeten uit de
 * productfotografie. Shopify levert bij een tweekleurige stelling maar één
 * kleur; dit bestand vult de tweede aan, zodat de twee overlappende cirkels
 * kloppen. Zie OPEN_QUESTIONS Q20.
 *
 * Toegankelijkheid: radiogroup met pijltjesbediening, elke knop heeft de
 * kleurnaam als aria-label, en de gekozen naam staat zichtbaar in tekst.
 */
(function () {
  'use strict';

  function applyPalette(card, palette) {
    var buttons = card.querySelectorAll('.okaya-way');
    for (var i = 0; i < buttons.length; i++) {
      var name = buttons[i].dataset.colour;
      var entry = palette[name];
      if (!entry) continue;
      var circles = buttons[i].querySelectorAll('i');
      if (circles.length < 2) continue;
      circles[0].style.background = entry.hex1 || circles[0].style.background;
      circles[1].style.background = entry.hex2 || entry.hex1 || circles[1].style.background;
    }
  }

  function wire(card) {
    var buttons = Array.prototype.slice.call(card.querySelectorAll('.okaya-way'));
    if (!buttons.length) return;
    var image = card.querySelector('.okaya-card__image');
    var nameEl = card.querySelector('.okaya-card__colour-name');
    // Twee links per kaart: de foto en de titel. Allebei moeten ze meelopen
    // met de gekozen kleur, anders klopt de bestemming niet met wat je ziet.
    var links = card.querySelectorAll('.okaya-card__media, .okaya-card__title a');

    function select(index) {
      buttons.forEach(function (b, i) {
        b.setAttribute('aria-checked', i === index ? 'true' : 'false');
        b.tabIndex = i === index ? 0 : -1;
      });
      var b = buttons[index];
      if (nameEl) nameEl.textContent = b.dataset.colour || '';
      if (image && b.dataset.image) {
        image.src = b.dataset.image;
        image.removeAttribute('srcset');
      }
      if (b.dataset.url) {
        for (var k = 0; k < links.length; k++) links[k].href = b.dataset.url;
      }
    }

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        select(i);
      });
      b.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % buttons.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + buttons.length) % buttons.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = buttons.length - 1;
        if (next === null) return;
        e.preventDefault();
        buttons[next].focus();
        select(next);
      });
    });
  }

  function start() {
    var cards = document.querySelectorAll('[data-okaya-card]');
    if (!cards.length) return;
    for (var i = 0; i < cards.length; i++) wire(cards[i]);

    var url = document.querySelector('[data-palette-url]');
    url = url ? url.dataset.paletteUrl : null;
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        if (!data || !data.colours) return;
        for (var i = 0; i < cards.length; i++) applyPalette(cards[i], data.colours);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
